import { PATHWAY } from '@/modules/httpService'
import copyToClipboard from './copyToClipboard'

async function notifyServerAndCopy (postId: string, text: string) {
  // ! regardless, we want to copy to clipboard
  copyToClipboard(text)

  try {
    console.log('text', text, 'postId', postId)
    await PATHWAY.post(`/posts/${postId}/shares`, {})
  } catch (err: unknown) {
    //
  }
}

export default notifyServerAndCopy
